<div class="container-fluid">

    <h4 id="upper">Consultation pdc par année ({{detailPdc.length || 0}})</h4>
    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">


                    <!-- Première ligne : Recherche par année + Bouton Exporter -->
                    <div class="row mb-2">
                        <div class="col-md-12 d-flex align-items-center justify-content-end gap-2">
                            <!-- Recherche par année -->
                            <p class="mt-3"> Rechercher par :</p> &nbsp;
                            <div class="d-flex align-items-center">
                                <label class="mb-0 me-2" style="white-space: nowrap;">Année:</label>
                                <input type="number" min="2000" [(ngModel)]="search_annee" name="search_annee"
                                    class="form-control form-control-sm me-2" />
                                <button style="white-space: nowrap;" (click)="getConsultationPdc()"
                                    class="btn btn-sm btn-primary">
                                    Rechercher <i class="pi pi-search"></i>
                                </button>

                            </div>

                            <!-- Bouton Exporter -->
                            <div class="dropdown" ngbDropdown>
                                <button type="button" ngbDropdownToggle class="btn btn-secondary dropdown-toggle"
                                    id="dropdownMenuButton" aria-haspopup="true" aria-expanded="false">
                                    Exporter <i class="pi pi-upload" style="font-size: 0.8rem"></i>
                                </button>
                                <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu
                                    aria-labelledby="dropdownMenuButton">
                                    <a class="dropdown-item" href="javascript:void(0);"
                                        (click)="exportToDocument('pdf')">Au format PDF</a>
                                    <a class="dropdown-item" href="javascript:void(0);"
                                        (click)="exportToDocument('excel')">Au format Excel</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Deuxième ligne : Filtres Programme & Action + Recherche texte -->
                    <div class="row mb-3">
                        <div class="col-md-12 d-flex align-items-center justify-content-end gap-2">
                            <!-- Filtre par Programme -->
                            <div>

                                <label class="d-inline-flex align-items-center mb-0" style="white-space: nowrap;">
                                 <p class="mt-3"> Filtrer par :</p> &nbsp;   Programme
                                    <select class="form-select form-control-sm ms-2" [(ngModel)]="selectedProgramma"
                                        (ngModelChange)="applyFilters()" (change)="onProgrammaChange()">
                                        <option value="">Tous les programmes</option>
                                        <option *ngFor="let pro of programmeList" [ngValue]="pro">{{ pro.libelle
                                            }}
                                        </option>
                                    </select>
                                </label>
                            </div>


                            <!-- Filtre par Action -->
                            <div>
                                <label class="d-inline-flex align-items-center mb-0" style="white-space: nowrap;">
                                    Action
                                    <select class="form-select form-control-sm ms-2" [(ngModel)]="selectedAction"
                                        (ngModelChange)="applyFilters()">
                                        <option value="">Toutes les actions</option>
                                        <option *ngFor="let action of actionsList" [value]="action.libelle">{{
                                            action.libelle
                                            }}</option>
                                    </select>
                                </label>
                            </div>


                            <!-- Recherche texte -->
                            <div>
                                <label class="d-inline-flex align-items-center mb-0" style="white-space: nowrap;">
                                    <input class="form-control" placeholder="Rechercher " type="text"
                                        [(ngModel)]="searchTerm" (ngModelChange)="applyFilters()">

                                </label>
                            </div>
                        </div>
                    </div>


                    <div class="table-responsive mt-3">
                        <table class="table table-centered datatable dt-responsive nowrap"
                            style="border-collapse: collapse; border-spacing: 0; width: 100%;">
                            <thead class="thead-light rwd-table">
                                <tr style="font-size: 12px;">
                                    <th style="width: 20px;font-size: 10px;">CODE</th>
                                    <th style="white-space: nowrap;">Programmes/Projets/Activités</th>
                                    <th>Indicateurs</th>
                                    <th>Source de vérification</th>
                                    <th>Responsable</th>
                                    <th style="white-space: nowrap;">Structures associées</th>
                                    <th>Localisation</th>
                                    <th style="white-space: nowrap;">Poids (%)</th>
                                    <th style="white-space: nowrap;">Coût total</th>
                                    <th colspan="1" class="text-center">Program. phys. et fin.</th>
                                    <th colspan="3" class="text-center">Sources de financement</th>
                                    <th></th> <!-- Actions -->
                                </tr>
                                <tr style="font-size: 12px;">
                                    <th colspan="9"></th>
                                    <ng-container *ngFor="let annee of anneesProgrammation">
                                        <th>{{ annee }}</th>
                                    </ng-container>
                                    <th>FADeC/FIC</th>
                                    <th>Non FADeC</th>
                                    <th>PTF</th>
                                    <th></th>
                                </tr>
                            </thead>

                            <tbody style="font-size: 12px;">
                                <ng-container *ngFor="let programme of paginatedProjets">
                                    <!-- LIGNE PROGRAMME -->
                                    <tr class="table-primary">
                                        <td>{{ programme.code }}</td>
                                        <td>{{ programme.libelle }}</td>
                                        <td colspan="16"></td>
                                    </tr>

                                    <!-- LIGNE ACTION -->
                                    <ng-container *ngFor="let action of programme.actions">
                                        <tr class="table-secondary">
                                            <td>{{ action.code }}</td>
                                            <td>{{ action.libelle }}</td>
                                            <td colspan="16"></td>
                                        </tr>

                                        <!-- LIGNE ACTIVITÉ -->
                                        <ng-container *ngFor="let activite of action.details_pdc_activites">
                                            <tr>
                                                <td>{{ activite.code }}</td>
                                                <td>{{ activite.libelle }}</td>
                                                <td>{{ activite.indicateur?.libelle }}</td>
                                                <td>{{ activite.indicateur?.source_verification }}</td>

                                                <td>{{ activite.service?.libelle }}</td>
                                                <td>{{ activite.structures_associees }}</td>
                                                <td>{{ activite.localisation }}</td>
                                                <td class="text-end">{{ activite.poids }}</td>
                                                <td style="white-space: nowrap;" class="text-end">{{ activite.mt_total |
                                                    formatMoney:null }}</td>

                                                <!-- Colonnes dynamiques par année -->
                                                <ng-container *ngFor="let annee of anneesProgrammation">
                                                    <td style="white-space: nowrap;" class="text-end">
                                                        {{
                                                        getMontantParAnneePourActivite(activite.details_pdc_financements_activites,
                                                        annee) | formatMoney:null }}
                                                    </td>
                                                </ng-container>

                                                <!-- Sources de financement -->
                                                <td style="white-space: nowrap;" class="text-end">{{ activite.mt_fadec |
                                                    formatMoney:null }}</td>
                                                <td style="white-space: nowrap;" class="text-end">{{ activite.mt_commune
                                                    | formatMoney:null }}</td>
                                                <td style="white-space: nowrap;" class="text-end">{{ activite.mt_ptf |
                                                    formatMoney:null }}</td>

                                                <!-- Action bouton -->
                                                <td>
                                                    <a (click)="updateLine(activite)" class="text-primary"
                                                        title="Modifier">
                                                        <i class="mdi mdi-pencil"></i>
                                                    </a>
                                                </td>
                                            </tr>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>


                    <div *ngIf="paginatedProjets.length === 0 && isLoading === true"
                        class="d-flex justify-content-center">
                        <div class="container">
                            <div class="row">
                                <div class="text-center">
                                    <h5 id="graycolor">Aucune donnée trouvée</h5>
                                </div>
                            </div>
                        </div>

                    </div>


                    <p-paginator (onPageChange)="onPageChangeProjets($event)" [first]="firstProjets"
                        [rows]="rowsProjets" [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 20, 30]">
                    </p-paginator>
                </div>
            </div>

        </div>

    </div>
</div>
<ng-template #detailModal let-modal>
    <div class="container-fluid">
        <br>
        <div class="d-flex justify-content-between align-items-center">
            <h4>Pdc Détaillé</h4>
            <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Close click')"> </button>
        </div>

    </div>
</ng-template>
<p-confirmDialog />
<p-toast />
<ngx-ui-loader></ngx-ui-loader>
